import React from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';
import 'css/common.less';
import {createStore, applyMiddleware, combineReducers, compose} from 'redux';
import thunkMiddleware from 'redux-thunk';
import {Provider} from 'react-redux';
import {Router, useRouterHistory} from 'react-router';
import createBrowserHistory from 'history/lib/createBrowserHistory'
import {syncHistoryWithStore, routerReducer, routerMiddleware} from 'react-router-redux';
import rootReducer from 'redux/reducer.js';
import {SET_VIEW_SCROLL_TOP} from 'redux/scrolltop/action';
import routeConfig from './router';
import auth from 'account/login.js';
import stats from 'stats';

stats.init();

var browserHistory = useRouterHistory(createBrowserHistory)();//{queryKey: false}

const createStoreWithMiddleware = compose(applyMiddleware(thunkMiddleware),
    applyMiddleware(routerMiddleware(browserHistory)),
    window.devToolsExtension ? window.devToolsExtension() : f => f)(createStore);
const reducer = combineReducers($.extend({}, rootReducer, {
    routing: routerReducer
}));

var loginUser = auth.getInfo();

const store = createStoreWithMiddleware(reducer, {
    loginUser: loginUser
});

var history = syncHistoryWithStore(browserHistory, store);

let rootElement = document.getElementById("root");

ReactDOM.render(
    (<Provider store={store}>
        <Router history={history} routes={routeConfig}/>
    </Provider>), rootElement);


// WEBPACK FOOTER //
// ./pages/main.jsx